import { defineTransform } from "../transform";
import { invertComponent } from "../invert";

// Object operations are completely independent of stack operations.
defineTransform("stack_create", "create_object", (op1, op2, side) => op1);
defineTransform("stack_create", "delete_object", (op1, op2, side) => op1);
defineTransform("stack_create", "update_property", (op1, op2, side) => op1);

// op2 has already happened, transform op1
defineTransform("stack_create", "stack_create", (op1, op2, side) => {
  // Same value inserted by both operations.

  if (op1.cs === op2.cs) {
    // Both operations are creating in the same location, no need to do op1.
    if (op1.p[1] === op2.p[1]) {
      return;
    }

    if (side === "left") {
      // Revert op2 and perform op1 instead.
      return [invertComponent(op2), op1];
    } else {
      // Keep op2, and don't do op1.
      return;
    }
  }

  if (op1.cs === op2.cs && op2.p[1] == op1.p[1]) {
    return;
  }

  // Adjust index of op1. Do it in a consistent way if they have the same index.
  if (op2.p[1] < op1.p[1] || (op2.p[1] === op1.p[1] && side === "left")) {
    return { p: ["stack", op1.p[1] + 1], cs: op1.cs };
  }

  // op1 and op2 are independent.
  return op1;
});

// op2 has already happened, transform op1
defineTransform("stack_create", "stack_delete", (op1, op2, side) => {
  if (op2.p[1] < op1.p[1]) {
    return { p: ["stack", op1.p[1] - 1], cs: op1.cs };
  }

  // op1 and op2 are independent.
  return op1;
});
